<template>
  <div class="container" ref="input">
    <div class="ggh-logo">
      <img src="@images/logo.jpg" alt>
    </div>
    <van-cell-group class="form-cell-group">
      <van-field v-model="username" clearable @input="check" label="帐号" placeholder="请输入帐号"/>
      <van-field
        v-model="password"
        clearable
        type="password"
        @input="check"
        label="密码"
        @blur="blur('input')"
        placeholder="请输入登录密码"
      />
    </van-cell-group>
    <van-row class="login-container">
      <van-col span="24">
        <van-button
          class="login-btn"
          :disabled="disabled"
          type="info"
          block
          @touchstart="login"
        >管理员登录</van-button>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import { LoginModel } from "@models/admin/login";
import { ERR_OK } from "@/common";
const loginModel = new LoginModel();
export default {
  data() {
    return {
      username: "",
      password: "",
      disabled: false
    };
  },
  methods: {
    login() {
      !this.disabled &&
        loginModel
          .checkLogin({
            username: this.username,
            password: this.password
          })
          .then(res => {
            if (res.code == ERR_OK) {
              //登录成功
              localStorage.setItem('id',res.data.id)
              localStorage.setItem('username',res.data.username)
              localStorage.setItem('user_token',res.data.user_token)
              localStorage.setItem('role',res.data.role)
              this.$redirect('/admin/index')
            } else {
              this.$dialog.alert({
                message: res.msg,
                confirmButtonText: "重新输入"
              });
            }
          });
    },
    check() { //表单验证
      this.username == "" || this.password == ""
        ? (this.disabled = true)
        : (this.disabled = false);
    },
    islogin() {
      localStorage.getItem('user_token') && localStorage.getItem('role') == 'admin' && this.$redirect('/admin/index')
    },
    blur(name) {  //修复bug
      this.$refs[name].scrollIntoView();
    }    
  },
  mounted() {
    this.islogin()
    this.check()
  }
};
</script>
<style lang="stylus" scoped>
@import '~@style/varibles.styl';

.ggh-logo {
  width: 3.5rem;
  margin: 0 auto;
  padding: 0.5rem 0;
}

.ggh-logo img {
  max-width: 100%;
}

.form-cell-group {
  padding: 0 0.1rem;
  padding-right: 0.4rem;
}

.login-container {
  margin-top: 1rem;
  padding: 0 0.3rem;
}

.login-btn {
  border-radius: 4px;
  background: $primary;
}

>>>[class*=van-hairline]::after {
  left: -42%;
  right: -41%;
  border-top: 0px solid #000;
}

>>>.van-field__label {
  max-width: 1.2rem;
}

>>>.van-field__control {
  height: 0.48rem;
}
</style>